import Keycloak from 'keycloak-js'
import { DARWIN_ROLES } from './const'
import { DarwinRoleType } from '../../types'

/**
 * Ritorna il nome utente estratto dal token
 */
export const getUserNameFromToken = (keycloak?: Keycloak) => {
  const parsed = getTokenParsed(keycloak)
  return parsed ? parsed.name ?? parsed.preferred_username : ''
}

/** Ritorna i ruoli dell'operatore Registro per l'applicazione Darwin estratti dal Token**/
export const userDarwinRoles = (keycloak: Keycloak) => keycloak?.resourceAccess?.['darwin-service']?.roles?.filter((role): role is DarwinRoleType => isValidDarwinUserType(role))

/** Ritorna i ruoli dell'operatore Registrar estratti dal Token **/
export const userDarwinRegistrarRoles = (keycloak: Keycloak): DarwinRoleType[] | undefined =>
  keycloak?.realmAccess?.roles?.filter((role): role is DarwinRoleType => isValidDarwinUserType(role))


/** Ritorna i ruoli assoluti dell'operatore Registry all'interno del REAME **/
export const userRealmRegistryOperatorRoles = (keycloak: Keycloak) => keycloak?.tokenParsed?.realm_access?.roles


/** Ritorna la sezione TokenParsed del token keycloak **/
export const getTokenParsed = (keycloak?: Keycloak) => {
  return keycloak?.tokenParsed as any | undefined
}

export const isValidDarwinUserType = (role: string): role is DarwinRoleType => {
  return Object.values(DARWIN_ROLES).includes(role as DarwinRoleType)
}

/** Ritorna il ruolo dell'utente nell'applicazione Darwin **/
// export function getUserDarwinRole(keycloak: Keycloak | undefined): string | undefined {
//   //  console.log(userDarwinRole.name, 'token:', keycloak)
//
//   /**
//    * Cerca il ruolo nell'array e vede se c'è il match
//    * @param role
//    * @param targetArrayRoles
//    */
//   function checkIfRoleExists(role: string, targetArrayRoles?: string[]) {
//     return targetArrayRoles?.some((current) => role === current)
//   }
//
//
//
//   if (keycloak?.realm === 'registrar') {
//     if (checkIfRoleExists('admin', userDarwinRegistrarRoles(keycloak))) {
//       return 'admin'
//     } else if (checkIfRoleExists('domain', userDarwinRegistrarRoles(keycloak))) {
//       return 'domain'
//     } else if (checkIfRoleExists('darwin', userDarwinRegistrarRoles(keycloak))) {
//       return 'darwin'
//     } else {
//       return undefined
//     }
//   } else if (keycloak?.realm === 'registry') {
//     if (checkIfRoleExists('darwin-admin', userDarwinRoles(keycloak))) {
//       return 'darwin-admin'
//     } else {
//       return undefined
//     }
//   }
//   return undefined
// }

export function getUserDarwinRole(keycloak?: Keycloak): DarwinRoleType | undefined {
  if (!keycloak) return undefined

  const checkIfRoleExists = (role: DarwinRoleType, targetArrayRoles?: DarwinRoleType[]) =>
    targetArrayRoles?.includes(role)

  if (keycloak.realm === 'registrar') {
    const roles = userDarwinRegistrarRoles(keycloak)
    const PARTIAL_DARWIN_ROLES = ['admin', 'domain', 'darwin'] as DarwinRoleType[]
    return PARTIAL_DARWIN_ROLES.find((role) => checkIfRoleExists(role, roles))
  }

  if (keycloak.realm === 'registry' && checkIfRoleExists('darwin-admin', userDarwinRoles(keycloak))) {
    return 'darwin-admin'
  }

  return undefined
}

/** Ritorna true se l'utente è un amministratore di Darwin **/
export const isRegistryUserDarwinAdmin = (keycloak: Keycloak) => getUserDarwinRole(keycloak) === 'darwin-admin'
export const isRegistrarUserDarwin = (keycloak: Keycloak) => getUserDarwinRole(keycloak) === 'darwin'
export const isRegistrarUserDomain = (keycloak: Keycloak) => getUserDarwinRole(keycloak) === 'domain'
export const isUserAdmin = (keycloak: Keycloak) => ['tech-admin', 'operator-admin', 'legal-admin', 'billing-admin', 'admin'].find((role) => role === getUserDarwinRole(keycloak))
